// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse {
    static getAttributeTypeMap() {
        return EnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse.attributeTypeMap;
    }
}
EnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse.discriminator = undefined;
EnrollmentMoveMemberNumberBySurveyQuestionResultModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentMoveMemberNumberBySurveyQuestionResultModel"
    }
];
//# sourceMappingURL=enrollmentMoveMemberNumberBySurveyQuestionResultModelResponse.js.map